import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Zap, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/api/auth/reset-password", { token, new_password: password });
      toast.success("Password reset. You can now sign in.");
      nav("/login");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-gradient-to-br from-[#d4af37] to-[#a3852c]">
            <Zap className="w-4 h-4 text-[#0a0b0e]" strokeWidth={3} />
          </div>
          <span className="font-display font-semibold text-white text-lg">LoftPress</span>
        </Link>
        <div className="lp-card p-8">
          <h1 className="font-display text-3xl text-white/95">Set a new password</h1>
          <p className="text-white/50 mt-2 text-sm">Pick a strong password at least 8 characters long.</p>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
            <input type="password" required minLength={8} className="lp-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" data-testid="reset-password" />
            <button type="submit" disabled={busy || !token} className="lp-btn-primary w-full justify-center" data-testid="reset-submit">
              {busy ? "…" : "Reset password"} <ArrowRight className="w-4 h-4" />
            </button>
            {!token && <div className="text-red-400 text-sm text-center">Missing token in URL.</div>}
          </form>
        </div>
      </motion.div>
    </div>
  );
}
